module.exports = __webpack_public_path__ + "img/MX-C048A-BS-HQ.44288f32.png";